"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR = void 0;
var ERROR;
(function (ERROR) {
    ERROR["POST_ID_MISSING"] = "Post id is missing";
    ERROR["ALL_FIELDS_REQUIRED"] = "All Fields Are Required";
    ERROR["EMPTY_FIELD"] = "Empty Field";
    ERROR["INVALID_USERNAME"] = "Invalid username, must be only letters";
    ERROR["INVALID_EMAIL"] = "Invalid email";
    ERROR["WEAK_PASSWORD"] = "Weak password";
    ERROR["DUPLICATE_USERNAME"] = "Username already exists";
    ERROR["DUPLICATE_EMAIL"] = "Email already exists";
    ERROR["INVALID_LOGIN"] = "Invalid login";
    ERROR["INVALID_PASSWORD"] = "Invalid password";
    ERROR["INCORRECT_PASSWORD"] = "Incorrect password";
    ERROR["INVALID_TOKEN"] = "Invalid token";
    ERROR["UNAUTHORIZED"] = "Unauthorized";
    ERROR["TOKEN_EXPIRED"] = "Token expired";
    ERROR["PARAMS_MISSING"] = "Params missing";
    ERROR["ALREADY_FOLLOWER"] = "You already follow this user";
    ERROR["ALREADY_UNFOLLOWER"] = "You already unfollow this user";
    ERROR["USER_NOT_FOUND"] = "User not found";
    ERROR["SPACE_NOT_FOUND"] = "Space not found";
    ERROR["BLOG_NOT_FOUND"] = "Blog not found";
    ERROR["COMMENT_NOT_FOUND"] = "Comment not found";
    ERROR["TAG_NOT_FOUND"] = "Tag not found";
    ERROR["PRIVATE_SPACE"] = "Private space, you need to be a member to access it";
    ERROR["PRIVATE_BLOG"] = "Private blog, it is posted in a private space";
    ERROR["SHORT_NOT_FOUND"] = "Short not found";
    ERROR["PRIVATE_SHORT"] = "Private short, it is posted in a private space";
    ERROR["EXPIRE_API"] = "Expire api";
    ERROR["OWNER_CANT_LEAVE"] = "You are the owner of this space, you can not leave it";
    ERROR["PERMISSION_DENIED"] = "Permission denied";
    ERROR["TAG_ALREADY_EXISTS"] = "Tag already exists";
})(ERROR || (exports.ERROR = ERROR = {}));
